import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

const RelatedProductsContainer = styled.div`
  height: 805px;
  width: 300px;
  display: grid;
`;

const RelatedProductsCardsJoomla = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 300px;
`;

const relatedProductsListJoomlaPropertyTypes = {
  children: PropTypes.node.isRequired,
};

type RelatedProductsListJoomlaProperties = InferProps<
  typeof relatedProductsListJoomlaPropertyTypes
>;

const RelatedProductsListJoomla = ({
  children,
}: RelatedProductsListJoomlaProperties) => (
  <RelatedProductsContainer className="related-products-list">
    <RelatedProductsCardsJoomla>
      { children }
    </RelatedProductsCardsJoomla>
  </RelatedProductsContainer>
);

RelatedProductsListJoomla.propTypes = relatedProductsListJoomlaPropertyTypes;

const RelatedProductsCards = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 24px;
  padding-top: 24px;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.12);

  @media (min-width: ${breakpoints.sm}px) {
    justify-content: space-around;
  }
`;

const relatedProductsListPropertyTypes = {
  children: PropTypes.node,
};

type RelatedProductsListProperties = InferProps<
  typeof relatedProductsListPropertyTypes
>;

const RelatedProductsList = ({ children }: RelatedProductsListProperties) => (
  <RelatedProductsCards>
    {children}
  </RelatedProductsCards>
);

RelatedProductsList.propTypes = relatedProductsListPropertyTypes;

export { RelatedProductsListJoomla, RelatedProductsList };
